<template>
  <div>
    <navbar/>
    <div>
      <div class="row m-0">
        <div class="col-lg-2 col-md-4 col-sm-4 col-xs-12">
    <sidebar/>
        </div>
        <div class="col-lg-10 col-sm-8 col-xs-12 col-md-8 routerView ">
        <router-view />
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '../navbar/navbar.vue'
import Sidebar from '../sidebar/sidebar.vue'
import Footer from '../footer/footer.vue'
export default {
  name: 'Layout',
 components: {
    Navbar,
    Sidebar,
    Footer
  }
}
</script>
<style src="./layout.scss" lang="scss" scoped/>
